import { UnstyledButton } from 'ui/components/ButtonV2/Button';
import Image from 'next/image';
import clsx from 'clsx';
export enum BgColors {
  WHITE = 'bg-white',
  GRAY = 'bg-gray-50',
}
export const UpgradeFamilyInfoCard = ({
  title,
  subtitle,
  bgColor = BgColors.WHITE
}: {
  title?: string;
  subtitle: string;
  bgColor?: BgColors;
}) => <div className='flex justify-center py-2' data-sentry-component="UpgradeFamilyInfoCard" data-sentry-source-file="UpgradeFamilyInfoCard.tsx">
    <div className={clsx('font-whoop border-gray-20 relative flex cursor-pointer flex-row items-start justify-between gap-4 rounded-3xl border p-5 text-left text-black shadow-sm hover:cursor-auto sm:max-w-lg', bgColor, bgColor === BgColors.GRAY ? 'border-none' : '')} data-testid='family-info-card'>
      <div className='flex h-full flex-col justify-center'>
        <Image alt='decorative icon' height={45} role='presentation' src={'/community-icon.svg'} width={45} data-sentry-element="Image" data-sentry-source-file="UpgradeFamilyInfoCard.tsx" />
      </div>
      <div className='flex flex-row items-start justify-between gap-3'>
        <div className='flex flex-col'>
          {title ? <div className='pb-3 text-lg font-bold leading-6 sm:text-xl'>
              <h3>{title}</h3>
            </div> : null}
          <p className='text-sm leading-4 sm:text-base' key={subtitle}>
            {subtitle}
          </p>
        </div>
      </div>
    </div>
  </div>;